import { option } from 'fp-ts';
import { getEdgeBounds } from '../GraphEdge';
import { fitToViewport } from '../helpers/fitToViewport';
import type { GraphRendererPlugin } from './GraphRendererPlugin';

export const fitEdgeToView: GraphRendererPlugin = (pluginInterface) => {
  const getMinViewportDimension = () =>
    Math.min(
      pluginInterface.viewport.screenWidth,
      pluginInterface.viewport.screenHeight,
    );

  pluginInterface.bindGraphCommandEventListener('fitEdgeToView', (event) => {
    const edge = pluginInterface.edgeDisplayObjects.get(event.edgeData.id);
    if (edge) {
      const bounds = getEdgeBounds(event.edgeData, edge);

      if (option.isNone(bounds)) {
        return;
      }

      const minViewportDimension = getMinViewportDimension();

      fitToViewport(
        pluginInterface.viewport,
        minViewportDimension / 4,
      )(bounds.value);
    }
  });
};
